// Real milliseconds that count as one "call minute" — governs BOTH how fast the
// minute balance is consumed (the learner's consume ticker) AND how fast the
// session countdown runs, so the two always stay in sync.
//
//   60_000 = real time (1 call-minute per real minute) — the PRODUCTION value.
//    5_000 = TEST speed-up (1 call-minute per 5 real seconds).
//
// Real time as of 2026-08-09. Lives here (not in the web bundle) because there
// are two clients: the web imports it directly and /api/token serves it to iOS
// as `msPerCallMinute`, so both bill the same call at the same rate.
export const REAL_MS_PER_CALL_MINUTE = 60_000;
/** Canonical credit packages. Display-only credits; `minutes` is what a purchase
 *  adds to the balance. Mirrored server-side in the credit_packages table
 *  (asserted equal by a test) — the client only ever sends a package id.
 *  Enterprise is deliberately absent: it is sold by contact, not self-serve
 *  (the web app renders an "Enterprise — contact us" row instead). */
export const PACKAGES = [
    { id: 'payg', name: 'Pay As You Go', credits: 1, minutes: 15, priceDollars: 15 },
    { id: 'starter', name: 'Starter', credits: 4, minutes: 60, priceDollars: 40 },
    { id: 'explorer', name: 'Explorer', credits: 40, minutes: 600, priceDollars: 390 },
    { id: 'enthusiast', name: 'Enthusiast', credits: 100, minutes: 1500, priceDollars: 950 },
    { id: 'pro', name: 'Pro', credits: 200, minutes: 3000, priceDollars: 1850 },
];
/** Canonical guide availability time slots. Mirrored server-side by
 *  apps/backend/src/routes/profile.ts (which validates incoming arrays
 *  against the ids here) and re-exported by apps/web's registration types
 *  under the same name for its existing importers. */
export const AVAILABILITY_SLOTS = [
    { id: '8am-1pm', label: '8am–1pm' },
    { id: '1pm-6pm', label: '1–6pm' },
    { id: '6pm-11pm', label: '6–11pm' },
    { id: '11pm-4am', label: '11pm–4am' },
    { id: '4am-8am', label: '4–8am' },
    { id: 'anytime', label: 'Anytime' },
];
/** Guide SMS consent, verbatim. This is legal text supplied by SignWow to meet
 *  Twilio / carrier A2P requirements — do not paraphrase, reflow or "tidy" it.
 *  Shown at registration (as an opt-in / decline pair) and in profile Settings,
 *  and recorded against the guide as SMS_CONSENT_VERSION so we always know
 *  which wording a given guide agreed to. Editing the wording means minting a
 *  new version string, never reusing the old one. */
export const SMS_CONSENT_VERSION = 'sms-2026-09-03';
/** The privacy policy the consent text points at. Declared separately so the
 *  UI can turn the URL inside SMS_CONSENT_TEXT into a real link without
 *  re-typing (and risking drifting from) the address. */
export const SMS_CONSENT_PRIVACY_URL = 'https://aslgo.com/legal#Privacy';
export const SMS_CONSENT_TEXT = 'I agree to receive recurring SMS/text messages from SignWow/ASL Go at the mobile number I provided ' +
    'alerting me when a Learner is available for an ASL session and inviting me to go to my ASL Go Deaf ' +
    'Guide account to view the request and choose whether to accept the session. I understand that these ' +
    'text notifications will only be activated while I am actively signed in to my ASL Go account. Message ' +
    'frequency varies based on Learner availability. Msg & data rates may apply. I can opt out at any time ' +
    'in my ASL Go account Settings or by replying STOP to cancel. Reply HELP for help. SMS consent is ' +
    'optional and is not required to register for or use ASL Go as a Deaf Guide. See our Privacy Policy ' +
    'at ' + SMS_CONSENT_PRIVACY_URL + '.';
export const SMS_DECLINE_TEXT = 'I do not agree to receive recurring SMS/text messages from SignWow/ASL Go and I understand that if I ' +
    'do not opt in to SMS, I may be limited to notifications for Learners who wish to have an ASL session with me.';
export { USER_ROLES, isUserRole } from './captions.js';
export * from './topic.js';
export * from './admin.js';
